<!-- eslint-disable -->
<template lang="pug">
    grade-form(v-if="grade && !isLoading" :grade="grade" :submit="update")
        template(slot="title") {{ $i18n.t('grade.grade_edit_title') }}
        template(slot="button") {{ $i18n.t('grade.grade_edit_button') }}
    cs-loader(v-else="")
</template>

<script>
    /*eslint-disable*/
    import GradeForm from './Form.vue';
    import GradeApi from '../../api/grade'
    export default {
        data() {
            return {
                grade: null,
                isLoading: false
            }
        },
        mounted() {
            this.fetchData();
        },
        props: ['id'],
        methods: {
            fetchData() {
                this.isLoading = true;
                GradeApi.show(this.id)
                .then((data) => {
                    this.grade = data;
                    this.isLoading = false;
                })
            },
            update(grade) {
                return GradeApi.update(this.id, grade);
            }
        },
        components: {
            GradeForm
        }
    }
</script>
